import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconUnmappedGames: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.875 3.75V14.25C1.875 14.6642 2.21079 15 2.625 15H5.25H6.75L5.625 10.875L8.25 10.125L7.875 7.5L10.875 6L10.125 4.875L11.25 3H2.625C2.21079 3 1.875 3.33579 1.875 3.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.125 14.25V3.75C16.125 3.33579 15.7892 3 15.375 3H14.25L12.75 5.25L13.875 7.125L10.5 8.625L10.875 11.625L8.25 12.375L9 15H15.375C15.7892 15 16.125 14.6642 16.125 14.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
